import { Box, Button, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useMemo } from 'react'; 
import { useLocation, useNavigate } from 'react-router-dom'; 

import { useAuthContext } from '../../../context';
import { SubNivelAcesso } from '../../../services/api/users/UserServices';

interface IVMRecordsProps {
	id: string;
}

export const VMRecords: React.FC<IVMRecordsProps> = ({ id }) => {
	const navigate = useNavigate();
	const location = useLocation(); 
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down('sm'));

	const { userData } = useAuthContext();

	const registrosPermissoes: SubNivelAcesso = useMemo(() => {
		return userData?.nivel_acesso?.registros || {};
	}, [userData]); 

	const isButtonActive = (path: string) => {
		return location.pathname === path;
	};

	const hasPermission = (permissionValue: string | null | undefined): boolean => {
		return typeof permissionValue === 'string' && permissionValue !== '';
	};

	return (
		<Box
			display={'flex'}
			flexDirection={smDown ? 'column' : 'row'}
			width={'100%'}
		>
			<Box
				display={'flex'}
				flexDirection={'column'}
				alignItems={smDown ? 'center' : 'start'}
				width={smDown ? '100%' : '50%'}
				padding={1}
			>
				<Typography variant='h6' color={theme.palette.primary.main} marginLeft={1}>Registros Legais</Typography>

				{hasPermission(registrosPermissoes.RISR) && (
					<Button variant={isButtonActive(`/information_dam/${id}/risr`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/risr`)}>
						<Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Relatórios de Inspeção de Segurança Regular (RISR)</Typography>
					</Button>
				)}

				{hasPermission(registrosPermissoes.RISROT) && (
					<Button variant={isButtonActive(`/information_dam/${id}/risrot`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/risrot`)}>
						<Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Relatórios de Inspeção de Rotina (RISROT)</Typography>
					</Button>
				)}

				{hasPermission(registrosPermissoes.RISE) && (
					<Button variant={isButtonActive(`/information_dam/${id}/rise`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/rise`)}>
						<Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Relatório Inspeção de Segurança Especial (RISE)</Typography>
					</Button>
				)}

				{hasPermission(registrosPermissoes.operacoes) && (
					<Button variant={isButtonActive(`/information_dam/${id}/operation_records`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/operation_records`)}>
						<Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registros de Operação</Typography>
					</Button>
				)}

				{/* Você precisará de uma chave como 'operation_history' em SubNivelAcesso e em suas permissões */}
				{/* {hasPermission(registrosPermissoes.operation_history) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/operation_history`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/operation_history`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registros de Operação (Histórico)</Typography>
                    </Button>
                )} */}

				{/* {hasPermission(registrosPermissoes.maintenance_history) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/maintenance_history`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/maintenance_history`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registros da Manutenção (Histórico)</Typography>
                    </Button>
                )} */}

				{hasPermission(registrosPermissoes.monitoramento) && (
					<Button variant={isButtonActive(`/information_dam/${id}/instrumentation_geotechnical_records`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/instrumentation_geotechnical_records`)}>
						<Typography overflow={'hidden'} whiteSpace={'discard'} textOverflow={'ellipsis'} variant='body2'>Registros de Monitoramento e Instrumentação</Typography>
					</Button>
				)}

				{/* {hasPermission(registrosPermissoes.safety_inspection_sheets) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/safety_inspection_sheets`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/safety_inspection_sheets`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Fichas de Inspeções de Segurança de Barragens</Typography>
                    </Button>
                )} */}

				{/* {hasPermission(registrosPermissoes.safety_inspection_sheets_history) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/safety_inspection_sheets_history`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/safety_inspection_sheets_history`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Fichas de Inspeções de Segurança de Barragens (Historico)</Typography>
                    </Button>
                )} */}

				{/* {hasPermission(registrosPermissoes.training_record_history) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/training_record_history`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/training_record_history`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registro de Treinamento (Histórico)</Typography>
                    </Button>
                )} */}
			</Box>
			<Divider orientation={smDown ? 'horizontal' : 'vertical'} flexItem variant="fullWidth" />
			<Box
				display={'flex'}
				flexDirection={'column'}
				alignItems={smDown ? 'center' : 'start'}
				width={smDown ? '100%' : '50%'}
				padding={1}
			>
				{/* {hasPermission(registrosPermissoes.equipment_records) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/equipment_records`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/equipment_records`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registros dos testes de equipamentos hidráulicos, elétricos e mecânicos</Typography>
                    </Button>
                )}
                {hasPermission(registrosPermissoes.kpi) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/kpi`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/kpi`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>KPI</Typography>
                    </Button>
                )}
                {hasPermission(registrosPermissoes.carpex_budget) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/carpex_budget`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/carpex_budget`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Orçamento CAPEX</Typography>
                    </Button>
                )}
                {hasPermission(registrosPermissoes.opex_budget) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/opex_budget`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/opex_budget`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Orçamento OPEX</Typography>
                    </Button>
                )}
                {hasPermission(registrosPermissoes.risk_matrix) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/risk_matrix`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/risk_matrix`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Matriz de riscos</Typography>
                    </Button>
                )}
                {hasPermission(registrosPermissoes.bimonthly_inspection) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/bimonthly_inspection`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/bimonthly_inspection`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Relatórios de inspeção bimestral e de desempenho</Typography>
                    </Button>
                )}
                {hasPermission(registrosPermissoes.geotechnical_report) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/geotechnical_report`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/geotechnical_report`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Relatório mensal de performance geotécnica</Typography>
                    </Button>
                )}
                {hasPermission(registrosPermissoes.hydric_balance) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/hydric_balance`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/hydric_balance`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Balanço hídrico</Typography>
                    </Button>
                )}
                {hasPermission(registrosPermissoes.mass_balance) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/mass_balance`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/mass_balance`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Balanço de massa</Typography>
                    </Button>
                )}
                {hasPermission(registrosPermissoes.bathymetries) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/bathymetries`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/bathymetries`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Batimetrias</Typography>
                    </Button>
                )}
                {hasPermission(registrosPermissoes.action_plan) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/action_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/action_plan`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de Ação</Typography>
                    </Button>
                )} */}
			</Box>
		</Box>
	);
};